import { i18n } from '@client/helper';

const { t } = i18n;

/**
 * type 字段在训练课程里面是 intensityCustom 或者 zoneType
 */
const basicConfig = [
  // 积极恢复区
  {
    index: 0,
    type: 1,
    _i18n: `G5019`,
    _i18n_custom: `SQ1102`,
    ratioRange: [0, 55],
    color: '#00AAFF'
  },
  // 有氧耐力区
  {
    index: 1,
    type: 2,
    _i18n: `S3687`,
    _i18n_custom: `SQ1103`,
    ratioRange: [56, 75],
    color: '#00D2E6'
  },
  // 有氧动力区
  {
    index: 2,
    type: 3,
    _i18n: `S3688`,
    _i18n_custom: `SQ1104`,
    ratioRange: [76, 90],
    color: '#1EBA1E'
  },
  // 乳酸阈区
  {
    index: 3,
    type: 4,
    _i18n: `S4345`,
    _i18n_custom: `SQ1105`,
    ratioRange: [91, 105],
    color: '#FAD20C'
  },
  // 速度耐力区
  {
    index: 4,
    type: 5,
    _i18n: `G5016`,
    _i18n_custom: `SQ1106`,
    ratioRange: [106, 120],
    color: '#FAAB0C'
  },
  // 无氧动力区
  {
    index: 5,
    type: 6,
    _i18n: `S3690`,
    _i18n_custom: `SQ1107`,
    ratioRange: [121, 150],
    color: '#ED6A0C'
  },
  // 冲刺区
  {
    index: 6,
    type: 7,
    _i18n: `G5017`,
    _i18n_custom: `G5024`,
    ratioRange: [150, ''],
    color: '#FF2638'
  }
];

// 骑行功率区间
export function getCyclePowerZone(from, userData, { zoneType } = {}) {
  if (from === 'schedule') {
    /**
     * 
      id: 6,
      type: 6,
      name: 'G5019',
      defaultName: 'G5019',
      color: '#00D2E6',
      range: [0, 142],
      ratioRange: [0, 80],
      nameText: '积极恢复区'
     */
    const { cyclePowerZone, ftp } = userData || {};
    // console.log(`🔔 cyclePowerZone`, cyclePowerZone, ftp);
    const length = cyclePowerZone ? cyclePowerZone.length : basicConfig.length;
    return basicConfig.map((item, index) => {
      const { _i18n } = item;

      const leftRatio = index === 0 ? 0 : basicConfig[index - 1].ratioRange[0];
      const rightRatio = index === length - 1 ? 0 : basicConfig[index].ratioRange[1];
      const itemResult = {
        ...item,
        name: _i18n,
        defaultName: _i18n,
        nameText: t(_i18n),
        ratioRangeText: `${leftRatio}-${rightRatio}`
      };
      // 已登录
      if (ftp) {
        // 数值范围   %ftp对应的绝对功率计算公式为=百分比*FTP值
        let left = index === 0 ? 0 : Math.round((cyclePowerZone[index - 1].ratio / 100) * ftp);
        // 中间的几个区间左值+1
        if (index !== 1 && index !== cyclePowerZone.length - 1) {
          left += 1;
        }
        const right = index === length - 1 ? 0 : Math.round((cyclePowerZone[index].ratio / 100) * ftp);
        itemResult.range = [left, right];
        itemResult.rangeText = `${left}-${right}`;
      }
      // 未登录范围值不会显示
      else {
        itemResult.range = [0, 0];
        itemResult.rangeText = '0-0';
      }
      return itemResult;
    });
  } else if (from === 'personalSetting') {
    return basicConfig.map((item) => {
      const { _i18n, _i18n_custom } = item;
      return {
        ...item,
        name: t(_i18n),
        rename: t(_i18n_custom),
        dot: item.color
      };
    });
  } else if (from === 'activity-detail') {
    return basicConfig.map((item) => ({
      ...item,
      // zoneType = 0时，显示区间1-区间7，zoneType = 1时，显示具体功率区间名称
      name: zoneType === 0 ? t(item._i18n_custom) : t(item._i18n)
    }));
  }
}
